<template>
    <div>
        <div style="float:right;margin-right:20px;">
            <StatusView style="margin-right:20px;"></StatusView>
<!--            <DeviceView></DeviceView>-->
            <MonitorView :isSenior="config.isSinglePage" style="margin-right:20px;"></MonitorView>
            <TransView ></TransView>
        </div>
    </div>
</template>

<script>
import StatusView from "./status/StatusView.vue";
import MonitorView from './monitor/MonitorView.vue';
import DeviceView from "./device/DeviceView.vue";
import TransView from "./trans/TransView.vue";
import BizChainIcon from "./status/bizChain/BizChainIcon.vue"
import {config} from 'cnetong-core-frontend';

export default {
    name: "Header",
    components: {StatusView, MonitorView, DeviceView, TransView, BizChainIcon},
    data: () => ({config})
}
</script>

<style scoped>
</style>
